import * as React from "react";

function SvgBasisIcon(props, ref) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 357.000000 312.000000"
      preserveAspectRatio="xMidYMid meet"
      {...{ ...props, ref }}
    >
      <g
        transform="translate(0.000000,312.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path d="M897 3102 c-19 -13 -159 -247 -458 -765 -390 -677 -430 -750 -427 -785 4 -57 848 -1511 890 -1535 27 -16 101 -17 883 -17 756 0 858 2 887 16 29 13 87 110 467 770 371 646 433 759 429 787 -2 19 -174 324 -437 775 -340 584 -439 745 -461 757 -25 13 -148 15 -887 15 -812 0 -859 -1 -886 -18z m2100 -842 l403 -701 -403 -700 -402 -699 -808 2 -809 3 -399 690 c-219 380 -399 696 -399 703 0 12 768 1359 793 1390 7 9 183 12 816 12 l806 0 402 -700z" />
        <path d="M950 1560 l0 -890 688 0 c422 0 712 4 752 10 146 24 276 115 338 240 43 85 55 155 50 291 -4 107 -7 122 -36 182 -18 36 -54 86 -80 112 -45 45 -154 105 -217 120 -29 6 -27 8 45 45 129 67 191 159 206 302 18 177 -66 341 -210 411 -127 62 -107 61 -853 65 l-683 3 0 -891z m1224 555 c52 -26 74 -58 87 -125 16 -76 -1 -133 -52 -182 -58 -56 -93 -60 -484 -56 l-340 3 -3 180 c-1 98 0 185 3 193 4 10 75 12 377 10 350 -3 375 -4 412 -23z m16 -686 c95 -22 149 -95 150 -203 0 -80 -18 -133 -60 -177 -62 -65 -90 -69 -522 -69 l-378 0 0 223 c0 123 3 227 7 230 11 11 753 8 803 -4z" />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgBasisIcon);
